var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTimecardActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.5,
    height: 20,
    viewBox: "0 0 17.5 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-time_card",
    d: "M10.25,4A2.261,2.261,0,0,0,8,6.25V9.607A2.763,2.763,0,0,0,6,12.25v9A2.761,2.761,0,0,0,8.75,24h12a2.761,2.761,0,0,0,2.75-2.75v-9a2.763,2.763,0,0,0-2-2.643V7.75a.75.75,0,0,0-.22-.53l-3-3A.75.75,0,0,0,17.75,4Zm0,1.5h7.189L20,8.061V9.5H9.5V6.25A.739.739,0,0,1,10.25,5.5ZM8.75,11h12A1.239,1.239,0,0,1,22,12.25v9a1.239,1.239,0,0,1-1.25,1.25h-12A1.239,1.239,0,0,1,7.5,21.25v-9A1.239,1.239,0,0,1,8.75,11Zm6,1.5A4.25,4.25,0,1,0,19,16.75,4.25,4.25,0,0,0,14.75,12.5ZM14.5,14a.5.5,0,0,1,.5.5v2h1.5a.5.5,0,1,1,0,1h-2A.5.5,0,0,1,14,17V14.5A.5.5,0,0,1,14.5,14Z",
    transform: "translate(-6 -4)",
    fill: "#555b70"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimecardActive);
export default __webpack_public_path__ + "static/media/iconTimecardActive.eada37b12c6b8a500b5f26fee8dc27a2.svg";
export { ForwardRef as ReactComponent };